import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import GoalValidations from 'scaleflow/validators/goal';

export default class GoalsGoalSelectorComponent extends Component {
  @service store;
  @tracked showDropdown = false;
  goalValidations = GoalValidations;

  @action isSelected(goal) {
    return this.goal.id == goal.id;
  }

  @action
  toggleDropdown(val) {
    if (val === undefined) this.showDropdown = !this.showDropdown;
    else this.showDropdown = val;
  }

  @action
  handleGoalSelect(goal) {
    this.toggleDropdown(false);
    this.args?.propagateGoalSelect?.(goal);
  }

  get goal() {
    return this.args.goal;
  }

  get goals() {
    return this.store
      .peekAll('goal')
      .map((item) => ({ label: item.title, value: item.id }));
  }
}
